import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopMswipe = dynamic(() => import("../../components/payment-partners/mswipe/DesktopMswipe"), {
    loading: () => <Loading />,
}
);

const MobileMswipe = dynamic(() => import("../../components/payment-partners/mswipe/MobileMswipe"), {
    loading: () => <Loading />,
}
);

const payuIntegration = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Mswipe Integrated With QueueBuster POS Software</title>
                <meta name="description" content="Accept payments & manage lines with ease! Pair Mswipe POS devices with QueueBuster POS." />
                <link rel="canonical" href="https://queuebuster.co/pos-payment-partners/mswipe" />
                <link rel="alternate" href="https://queuebuster.co/pos-payment-partners/mswipe" hrefLang="en-us" />
                <meta property="og:title" content="Mswipe Integrated With QueueBuster POS Software" />
                <meta property="og:description" content="Accept payments & manage lines with ease! Pair Mswipe POS devices with QueueBuster POS." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/mswipe.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-payment-partners/mswipe" />
            </Head>
            {mobileView ? <MobileMswipe /> : <DesktopMswipe />}
        </>
    )
}

export default payuIntegration